import { useCallback } from 'react'

import { useTranslateMutation } from '~generated/hooks'
import { Language, TranslateInput } from '~generated/types'
import { capitalize } from '~lib/textFormat'

type SupportedLanguage = {
  value: Language
  label: string
}

const supportedLanguages: SupportedLanguage[] = Object.keys(Language).map((value: Language) => {
  return {
    value,
    label: capitalize(value.split('_').join(' '), true),
  }
})

function useTranslateText() {
  const [mutation, { loading }] = useTranslateMutation()

  const translate = useCallback(
    async (input: TranslateInput) => {
      const { data: { translate: res } = {} } = await mutation({ variables: { input } })
      return res
    },
    [mutation]
  )

  return {
    languages: supportedLanguages,
    translate,
    loading,
  }
}

export default useTranslateText
